/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import { DashboardRunCompleteStatus } from '../models/DashboardRunCompleteStatus';


export class LookerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Post Dashboard Run Complete
     * @param locationGroupId
     * @param sessionData
     * @returns DashboardRunCompleteStatus Successful Response
     * @throws ApiError
     */
    public postDashboardRunComplete(locationGroupId: number, sessionData?: string): CancelablePromise<DashboardRunCompleteStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/looker/dashboards/run/complete/{locationGroupId}',
            path: {
                locationGroupId: locationGroupId
            },
            headers: {
                'session-data': sessionData
            },
            errors: {
                422: `Validation Error`
            }
        });
    }
}
